import CaseService from "./CaseService";

export default CaseService;
